import React from 'react';
import Conditional from '../../common/conditional';

import { ButtonProps } from '../../../utils/models';
import { concatClassNames } from '../../../utils/utilities';

import css from './button.module.scss';

const Button: React.FC<ButtonProps> = (props): JSX.Element => {
	return (
		<button
			className={css.button}
			disabled={props.disabled}
			onClick={props.onClick}
			{...props}
		>
			<Conditional isVisible={!!props.icon}>
				<i className={concatClassNames(['bi', 'bi-' + props.icon])}></i>
			</Conditional>

			<Conditional isVisible={!!props.label}>
				<span>{props.label}</span>
			</Conditional>
		</button>
	);
};

export default Button;
